import { Document } from "@customTypes/responses/document";
import React from "react";
import { AttachmentLinkButton } from "./style";
import { downloadDocumentModel } from "@services/documents";
import { Tooltip } from "nectar-ui";

type DocumentItemDownloaderProps = {
  document: Document;
};

const DocumentItemDownloader: React.FC<DocumentItemDownloaderProps> = ({ document }) => {
  const { url, originId, downloadUrls } = document;

  const isBlobDownload = !url && originId;

  const handleClick = async () => {
    const response = await downloadDocumentModel(originId);
    const documentModelPage = window.open("", "_blank");
    documentModelPage.document.write(response);
    documentModelPage.focus();
    setTimeout(() => {
      documentModelPage.print();
    }, 1000);
  };

  return (
    <Tooltip title="Visualizar" isVisible placement="top" preventOverflow>
      {isBlobDownload ? (
        <AttachmentLinkButton link onClick={handleClick} target="_blank">
          {downloadUrls[0]}
        </AttachmentLinkButton>
      ) : (
        <AttachmentLinkButton link href={url} key={url} target="_blank">
          {url}
        </AttachmentLinkButton>
      )}
    </Tooltip>
  );
};

export default DocumentItemDownloader;
